<template lang="pug">
.section.content
  div.has-text-weight-semibold About {{ title }}
  p Version {{ version }}.
</template>

<script>
import Constants from '@/constants'

export default {
  computed: {
    title () {
      return Constants.TITLE
    },
    version () {
      return Constants.VERSION
    }
  }
}
</script>
